import {emailSignIn, googleSignIn, resetErrorMessage} from "actions/authAction"
import {connect} from 'react-redux';
import SignIn from 'views/signup/SignIn'

const mapStateToProps = ({auth: {user, loginError, loginErrorMessage, inMaintenance, isVerifying}}) => {
  return ({
    user, loginError, loginErrorMessage, inMaintenance, isVerifying
  })
}

export default connect(mapStateToProps, {emailSignIn, googleSignIn,resetErrorMessage})(SignIn);
